import { render, staticRenderFns } from "./EventConfParticipant.vue?vue&type=template&id=1bfab9e7&"
import script from "./EventConfParticipant.vue?vue&type=script&lang=js&"
export * from "./EventConfParticipant.vue?vue&type=script&lang=js&"
import style0 from "./EventConfParticipant.vue?vue&type=style&index=0&id=1bfab9e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports